/*
Sohel 03/24/2023 2701335619 Added Logic Field in Fields
Sohel 03/28/2023 2701335619 processor fields added logic field
Sohel 03/29/2023 2701335619 Added outlet spacings.
Dilip 04/29/2023 2701335619 changed field type dropdown values.
Dilip 04/29/2023 2701335619 Fixed field type reset issue.
Sohel 04/19/2023 2698964415 Added Data Calculation Field
Sohel 04/27/2023 4136387705 Added Data Calculation Field
Prakash 03/07/2023 4136387705 fixed pop up alignments issues in tab view.
Sohel 10/10/2023 2805568664 Add field based on repository name and field name
Sohel 11/30/2023 2805568664 Fixed Data Calculation Field Code Reset Issue
Gireesh 11/12/2023 2805568664 added data calculation search field code issue
Sohel 12/12/2023 2701335619 label name change code to name 
*/
import {Button, TextField} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useEffect, useState, useRef, useContext} from 'react';
import {
  filteredCheckedData,
  filteredCheckedFieldTypeData,
  tempSelectFieldTypeFunc,
  tempSelectFunc,
} from '../../../../../../util/Functions';
import {useSelector, useDispatch} from 'react-redux';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {
  getAllFieldType,
  getBaseCategory,
  getFieldType,
} from '../../../../../../redux/reducers/GlobalField/AddFieldList';
import SearchTable from './SearchTable';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
const SearchForm = ({
  setAuditFieldValue,
  dmValues,
  setTempSelectedRows,
  tempSelectedRows,
  handleClose,
  deletedProcessorFields,
  dmRecordCategory,
  deletedIds,
  setDeletedIds,
  isRecordFormat,
  isTriggerMaintenance = false,
  isCustomWindow,
  setCustomWindowFieldValue = () => {},
  refValues = {},
  deletedRules,
  setDeletedRules,
  getFieldPosition = () => {},
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const tempUnCheckedRef = useRef();
  const {baseCategoryData, allFieldTypeData} = useSelector(
    ({addFieldList}) => addFieldList,
  );
  const initialState = {
    category: dmRecordCategory || '',
    fieldName: '',
    fieldType: '',
    repositoryName: "",
  };

  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    setSearchData({...initialState, category: dmRecordCategory});
  }, [dmRecordCategory]);
  const onClear = () => {
    const data = {
      category: dmRecordCategory || '',
      fieldName: '',
      fieldType: '',
      repositoryName: '',
    };
    setSearchData(data);
  };
  useEffect(() => {
    dispatch(getBaseCategory());
    dispatch(getFieldType());
    dispatch(getAllFieldType());
  }, []);
  useEffect(() => {
    if (setTempSelectedRows) {
      setTempSelectedRows([]);
      tempUnCheckedRef.current = [];
    }
  }, []);

  return (
    <>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialState}
          enableReinitialize
        >
          {(props) => {
            const {values, handleBlur, handleChange, handleReset, handleSubmit, setFieldValue} =
              props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <div className="form-row global-field-textfields new-standard-textfields">
                    <div className="col-sm-6 col-md-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="category"
                        id="category"
                        size="small"
                        value={values.category}
                        disabled
                        options={baseCategoryData || []}
                        getOptionLabel={(option) => {
                          return option && option?.categoryName ?
                            option?.categoryCode === null ?
                              option?.categoryName :
                              option?.categoryCode + ' - ' + option?.categoryName :
                            '';
                        }}
                        autoHighlight
                        onChange={(e, value) => {
                          setFieldValue('category', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Data Calculation Name"
                        margin="dense"
                        name="repositoryName"
                        value={values.repositoryName}
                        variant="outlined"
                        label="Data Calculation Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue('repositoryName', e.target.value);
                        }}
                        fullWidth
                      />
                    </div>
                    <div className="col-sm-6 col-md-5  col-lg-3 col-xl-3 form-group">
                      <TextField
                        className={`${classes.labelName}`}
                        placeholder="Enter Data Calculation Description"
                        margin="dense"
                        name="fieldName"
                        value={values.fieldName}
                        variant="outlined"
                        label="Data Calculation Description"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        fullWidth
                      />
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-3 col-lg-3 col-xl-3`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="fieldType"
                        id="fieldType"
                        size="small"
                        value={values.fieldType}
                        options={allFieldTypeData || []}
                        getOptionLabel={(option) => {
                          return option ? option : '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('fieldType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Field Type"
                              placeholder="Select Field Type"
                            />
                          </div>
                        )}
                      />
                    </div>

                    {/* <div className="col-md-9 col-lg-12 form-group"> */}
                    {/* <div className="d-flex"> */}
                    <div className="col-md-5 col-lg-7 form-group ">
                      <div className=" d-flex justify-content-end">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                              Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                              Search
                        </Button>
                      </div>
                    </div>
                    <div className="col-md-4 col-lg-5  form-group">
                      <div className="d-flex justify-content-end mb-2">
                        <Button
                          variant="outlined"
                          className={`reset-btn mr-1`}
                          onClick={() => {
                            handleClose();
                          }}
                        >
                              Close
                        </Button>
                        <Button
                          variant="outlined"
                          className={`search-btn ml-1`}
                          onClick={() => {
                            if (!isTriggerMaintenance && !isCustomWindow) {
                              if (dmValues && !isRecordFormat) {
                                const obj = tempSelectFieldTypeFunc(
                                  'fieldName',
                                  'repositoryName',
                                  'processorFieldType',
                                  tempUnCheckedRef,
                                );
                                const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedFieldTypeData(
                                        dmValues.selectedFields,
                                        obj,
                                        'fieldName',
                                        'repositoryName',
                                        'processorFieldType',
                                      );
                                const allSelectedRows = [
                                  ...newSelectedRows,
                                  ...tempSelectedRows,
                                ];
                                setAuditFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.processorId) {
                                      allDeleteIds.push(el.processorId);
                                    }
                                  });
                                  if (allDeleteIds.length > 0) {
                                    deletedProcessorFields.current = [
                                      ...deletedProcessorFields.current,
                                      ...allDeleteIds,
                                    ];
                                  } else {
                                    deletedProcessorFields.current = [
                                      ...deletedProcessorFields.current,
                                      0,
                                    ];
                                  }
                                }
                              }
                              if (isRecordFormat && dmValues) {
                                const obj1 = tempSelectFieldTypeFunc(
                                  'fieldName',
                                  'repositoryName',
                                  'mapFieldType',
                                  tempUnCheckedRef,
                                );
                                const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedFieldTypeData(
                                        dmValues.selectedFields,
                                        obj1,
                                        'fieldName',
                                        'repositoryName',
                                        'mapFieldType',
                                      );
                                const position = getFieldPosition(dmValues);
                                const newTempRows = tempSelectedRows.map((item, i) => {
                                  return {
                                    ...item,
                                    fieldPosition: position + i,
                                  };
                                });
                                const allSelectedRows = [
                                  ...newSelectedRows,
                                  ...newTempRows,
                                ];
                                setAuditFieldValue('selectedFields', allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.dataManagerRecordFieldId) {
                                      allDeleteIds.push(el.dataManagerRecordFieldId);
                                    }
                                  });

                                  const ids = [...deletedIds, ...allDeleteIds];
                                  setDeletedIds(ids);
                                }
                              }
                            }
                            if (isTriggerMaintenance) {
                              const obj = tempSelectFunc(
                                'fieldName',
                                'repositoryName',
                                tempUnCheckedRef,
                              );
                              const [newSelectedRows, newUnSelectedRows] = filteredCheckedData(
                                dmValues,
                                obj,
                                'fieldName',
                                'repositoryName',
                              );
                              const allSelectedRows = [...newSelectedRows, ...tempSelectedRows];
                              setAuditFieldValue(allSelectedRows);
                              if (newUnSelectedRows.length > 0) {
                                const allDeleteIds = [];
                                newUnSelectedRows.forEach((el) => {
                                  if (el.formulaFieldMapId) {
                                    allDeleteIds.push(el.formulaFieldMapId);
                                  }
                                });
                                if (allDeleteIds.length > 0) {
                                  deletedProcessorFields.current = [
                                    ...deletedProcessorFields.current,
                                    ...allDeleteIds,
                                  ];
                                } else {
                                  deletedProcessorFields.current = [
                                    ...deletedProcessorFields.current,
                                    0,
                                  ];
                                }
                              }
                            }
                            if (isCustomWindow) {
                              if (setAuditFieldValue) {
                                const obj = tempSelectFunc(
                                  'fieldName',
                                  'repositoryName',
                                  tempUnCheckedRef,
                                );
                                const [newSelectedRows, newUnSelectedRows] =
                                      filteredCheckedData(
                                        dmValues,
                                        obj,
                                        'fieldName',
                                        'repositoryName',
                                      );

                                tempSelectedRows?.forEach((r) => {
                                  setCustomWindowFieldValue(
                                    'fieldHeader' + r.repositoryName + r.fieldName,
                                    r.fieldLabel,
                                  );
                                  setCustomWindowFieldValue(
                                    'mandatoryField' + r.repositoryName + r.fieldName,
                                    r?.isMandatory,
                                  );
                                  setCustomWindowFieldValue(
                                    'viewOnlyField' + r.repositoryName + r.fieldName,
                                    r?.viewOnly,
                                  );
                                });
                                const allSelectedRows = [
                                  ...newSelectedRows,
                                  ...tempSelectedRows,
                                ];
                                setAuditFieldValue(allSelectedRows);
                                if (newUnSelectedRows.length > 0) {
                                  const allDeleteIds = [];
                                  newUnSelectedRows.forEach((el) => {
                                    if (el.fieldId) {
                                      allDeleteIds.push(el.fieldId);
                                    }
                                  });

                                  const ids = [...deletedRules, ...allDeleteIds];
                                  setDeletedRules(ids);
                                }
                              }
                            }
                            setTempSelectedRows([]);
                            handleClose();
                          }}
                        >
                              Save
                        </Button>
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                  {/* </div> */}
                </form>
              </div>
            );
          }}
        </Formik>
        <SearchTable
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setAuditFieldValue={setAuditFieldValue}
          dmValues={dmValues}
          setTempSelectedRows={setTempSelectedRows}
          tempSelectedRows={tempSelectedRows}
          handleClose={handleClose}
          deletedProcessorFields={deletedProcessorFields}
          dmRecordCategory={dmRecordCategory}
          tempUnCheckedRef={tempUnCheckedRef}
          isRecordFormat={isRecordFormat}
          isTriggerMaintenance={isTriggerMaintenance}
          isCustomWindow={isCustomWindow}
        />
      </div>
    </>
  );
};
export default SearchForm;
